import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Post          from '@common/post/_post';
import ContentsModal from '@partials/contents-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showSendFirstDmModal = this.showSendFirstDmModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal           : false,
      targets         : [],
      send_id         : null,
      copy_mode       : null,
      reference_modal : false,
      reference_user  : {},
      reference_post  : [],
      reference_word  : null,
    };
  }
  // -------------------------------------------------------
  
  showSendFirstDmModal(targets) {
    this.setState({ modal: true, targets: targets, send_id: null });
  }
  // -------------------------------------------------------
  
  closeAssignModal() {
    this.setState({ modal: false, targets: [] });
  }
  // -------------------------------------------------------
  
  getProfile(insta_user_id, reference_post) {
    Utils.request.bind(this)('/api/influencer/detail', { project_id: this.props.data.project.id, insta_user_id: insta_user_id },
      function(res){
        
        let ary = [];
        try { if( reference_post != null ) ary = reference_post.split(','); } catch(e) {}
        this.setState({ reference_modal: true, reference_user: res.body.data, reference_post: ary, reference_word: null });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closePostModal() {
    this.setState({ reference_modal: false });
  }
  // -------------------------------------------------------
  
  copy(target) {
    let project = this.props.data.project;
    let detail = project.detail;
    
    // メッセージの生成
    let message_text = Utils.createDmMessage(detail.invitation_message, { target: target, project: project, userData: this.props.data.userData });
    
    // メッセージコピー
    var textarea = document.getElementById('copy_zone');
    textarea.value = message_text;
    textarea.select();
    document.execCommand('copy');
    
    this.setState({ send_id: target.insta_user_id, copy_mode: 'active' });
    
    setTimeout( function(){ this.setState({ copy_mode: 'deactive' }); }.bind(this), 1000);
  }
  // -------------------------------------------------------
  
  multiAction(shortcode, e) {
    e.stopPropagation();
    e.preventDefault();
    
    let reference_post = this.state.reference_post;
    if( reference_post.indexOf(shortcode) == -1 ){
      reference_post.push(shortcode);
    } else {
      reference_post = reference_post.filter((s) => { if( shortcode != s ) return s; });
    }
    
    Utils.request.bind(this)('/api/project/influencer/seve_reference_post', { project_id: this.props.data.project.id, insta_user_id: this.state.reference_user.insta_user_id, posts: reference_post },
      function(res){
        this.props.data.event.updateData.bind(this)('workflow', res.body.workflow);
      }.bind(this)
    );
    
    this.setState({ reference_post: reference_post });
  }
  // -------------------------------------------------------
  
  changeKeyword() {
    this.setState({ reference_word: this.keyword.value });
  }
  // -------------------------------------------------------
  
  completeAction(insta_user_id, flg) {
    
    let status = (flg == true) ? 'assign_target_dm_ok' : 'assign_target';
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: this.props.data.project.id, insta_user_id: insta_user_id, update: { column: 'progress', value: status } },
      function(res){
        this.props.data.event.updateData.bind(this)('workflow', res.body.workflow);
      }.bind(this)
    );
    
    this.setState({ reference_post: reference_post });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let detail = base.project.detail;
    
    let influencers = [];
    this.state.targets.map((id) => {
      let inf = base.workflow.influencers[id];
      if( inf != undefined ) influencers.push(inf);
    });
    
    let is_reference_post = false;
    try { if( detail.invitation_message.indexOf('{post}') >= 0 ) is_reference_post = true; } catch(e) {}
    
    return (
      <div className="project-send-first-dm-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {600}
          height    = {500}
          close_ev  = {this.closeAssignModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>初回DM送信</h2>
              <h4>インフルエンサーを選択することでリンクとメッセージが表示されます</h4>
              
              { (detail.invitation_message == null || detail.invitation_message == '')
                ? <div className="message-none">
                    <p>初回メッセージ用のテンプレートが作成されていません。</p>
                    <p>設定は<a href={'/project-create/'+ base.project.unique_code +'/dm'} target="_blank">こちら</a>からお願いします。</p>
                  </div>
                : <ul className="influencers">
                    { influencers.map((d, key) => {
                      
                      let dm_link = 'https://www.instagram.com/direct/inbox/';
                      if( d.dm_account_id != null ) dm_link = 'https://www.instagram.com/direct/t/'+ d.dm_account_id +'/';
                      
                      let reference_count = 0;
                      try { d.status.reference_post.split(',').map((m) => { if( m != '' ) reference_count += 1; }); } catch(e) {}
                      
                      let dm_complete = false;
                      if( d.progress == 'assign_target_dm_ok' ) dm_complete = true;
                      
                      return (
                        <li key={key} className={d.progress}>
                          <p className="thumbnail"><img className="base-img" src={d.thumbnail} /></p>
                          <p className="insta-id">@{d.insta_id}</p>
                          
                          <div className="button copy" onClick={this.copy.bind(this, d)}>本文コピー</div>
                          
                          { (this.state.send_id == d.insta_user_id)
                            ? <a href={dm_link} target="_blank"><div className="button send">DM画面へ</div></a>
                            : <div className="button off send">DM画面へ</div>
                          }
                          
                          <div className="after-option">
                            { (is_reference_post == true)
                              ? <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>参考となった投稿を選択</Tooltip>}>
                                  <p className="on" onClick={this.getProfile.bind(this, d.insta_user_id, d.status.reference_post)}><i className="material-icons">add_photo_alternate</i></p>
                                </OverlayTrigger>
                              : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>参考となった投稿を選択（※テンプレートに{'{post}'}を入れると利用可能）</Tooltip>}>
                                  <p className="off"><i className="material-icons">add_photo_alternate</i></p>
                                </OverlayTrigger>
                            }
                            
                            {(dm_complete == true)
                              ? <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>完了ステータスを戻したい場合は、こちらのボタンを押して下さい</Tooltip>}>
                                  <p className="on" onClick={this.completeAction.bind(this, d.insta_user_id, false)}>戻る</p>
                                </OverlayTrigger>
                              : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>DMの送信が完了した場合にボタンを押してください</Tooltip>}>
                                  { (this.state.send_id == d.insta_user_id) ? <p className="on" onClick={this.completeAction.bind(this, d.insta_user_id, true)}>完了</p> : <p className="off">完了</p> }
                                </OverlayTrigger>
                            }
                            
                            {(reference_count > 0) && <span className="reference-count">{reference_count}</span>}
                          </div>
                          
                          { ( d.dm_account_id == null ) &&
                            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip><div>現在、直接URLに遷移するための情報を取得中です。<br />しばらくお待ちいただければ完了しますのでお待ち下さい。</div></Tooltip>}>
                              <i className="material-icons warning">warning</i>
                            </OverlayTrigger>
                          }
                          
                        </li>
                      );
                    })}
                  </ul>
              }
              
              <textarea className="none" id="copy_zone" />
              
              <p className={'clip-copy '+ this.state.copy_mode}>初回DM用の本文をコピーしました！</p>
            </div>
          }
        />
        
        <ContentsModal
          view      = {this.state.reference_modal}
          width     = {625}
          height    = {550}
          close_ev  = {this.closePostModal.bind(this)}
          html      = {
            <div className="modal-item reference-modal">
              <h2>参考となった投稿を選択</h2>
              <h4>選択した投稿をDMの内容に含めることができます</h4>
              
              <div className="search-box">
                <input className="text" type="text" ref={(input) => { this.keyword = input }} onChange={this.changeKeyword.bind(this)} placeholder="投稿を検索" />
                <i className="material-icons">search</i>
              </div>
              
              { (Object.keys(this.state.reference_user).length > 0) &&
                <ul>
                  { this.state.reference_user.posts.map((d, key) => {
                    
                    if( this.state.reference_word != null && this.state.reference_word != '' ){
                      if( d.text == null || d.text.indexOf(this.state.reference_word) == -1 ) return null;
                    }
                    
                    return (
                      <li key={key}>
                        {(this.state.reference_post.indexOf(d.shortcode) >= 0)
                          ? <div className="checkbox-frame" onClick={this.multiAction.bind(this, d.shortcode)}>
                              <input type="checkbox" id={'p_'+ d.shortcode} className="checkbox" defaultChecked disabled={true} />
                              <label className="checkbox" htmlFor={'p_'+ d.shortcode} />
                            </div>
                          : <div className="checkbox-frame off" onClick={this.multiAction.bind(this, d.shortcode)}>
                              <input type="checkbox" id={'pn_'+ d.shortcode} className="checkbox" />
                              <label className="checkbox" htmlFor={'pn_'+ d.shortcode} />
                            </div>
                        }
                        
                        <Post data={d} />
                      </li>
                    );
                  })}
                </ul>
              }
              
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;